<div class="modal">
  <div class="modal-overlay" (click)="close($event)"></div>

  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <a class="mr-2" (click)="close($event)">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </a>
      </div>

      @if (modalText != undefined) {
        <div class="modal-body">
          <div class="text-center" [innerHtml]="modalText"></div>
        </div>
      }
      <div class="modal-footer">
        <a class="mr-2" (click)="yes($event)">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" i18n="@@DialogConfirmYesButton">Yes</button>
        </a>
        <a (click)="no($event)">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" i18n="@@DialogConfirmNoButton">No</button>
        </a>
      </div>
    </div>
  </div>
</div>
